import React, { useState, useEffect } from 'react';
import EldComponent from './EldComponent';
import IntComponent from './IntComponent';
import CountryComponent from './CountriesComponent';
import LogisticsComponent from './LogisticsComponent';
import OtherComponent from './OtherComponent';
import EspComponent from './EspComponent.js';
import { Button } from 'primereact/button';
import { BlockUI } from 'primereact/blockui';
import ObjectID from 'bson-objectid';
import { useSelector, useDispatch } from 'react-redux';
import {
  showEldDialog,
  showIntDialog,
  showCtyDialog,
  showLogDialog,
  showOthDialog,
  showEspDialog,
} from '../../redux/actions/dialogActions.js';
import { setClient, setModType } from '../../redux/actions/logActions';
import { fetchInitialPosts } from '../../redux/thunk/thunk';
import { fixDateLog, sameDayWplFixWhileAddingPost, sameDayWorkingHFixWhileAddingPost } from '../common/utils/utils.js';
import { dictionary } from '../../dictionary.js';
const isDevelopment = process.env.NODE_ENV === 'development';
const API_URL = isDevelopment
  ? process.env.REACT_APP_API_URL
  : 'https://eld-timer-backend-service.api.prod.sit.sys.odj.cloud/';

const UserSelection = (props) => {
  const dispatch = useDispatch();
  const contentProps = props.contentProps;
  const isDialogOpen = useSelector((state) => state.showDialog.show);
  const dialogType = useSelector((state) => state.showDialog.type);
  const dateLog = new Date(useSelector((state) => state.date.value));
  const clientLog = useSelector((state) => state.client.value);
  const commentLog = useSelector((state) => state.comment.value);
  const ctyLog = useSelector((state) => state.cty.value);
  const langLog = useSelector((state) => state.lang.value);
  const espLog = useSelector((state) => state.esp.value);
  const hourLog = useSelector((state) => state.hours.value);
  const modTypeLog = useSelector((state) => state.modType.value);
  const moduleLog = useSelector((state) => state.module.value);
  const stageLog = useSelector((state) => state.stage.value);
  const taskLog = useSelector((state) => state.task.value);
  const wplLog = useSelector((state) => state.wpl.value);
  const whLog = useSelector((state) => state.wh.value);
  const versionLog = useSelector((state) => state.version.value);
  const formattedDate = `${dateLog.getDate()}/${dateLog.getMonth() + 1}/${dateLog.getFullYear()}`;
  const disabledDays = [0, 6];
  const [showOverlay, setShowOverlay] = useState(true);
  const [loading, setLoading] = useState(false);
  const [wplArr, setWplArr] = useState([]);

  useEffect(() => {
    if (
      Array.isArray(contentProps.eldData) &&
      contentProps.eldData.length > 0 &&
      Array.isArray(contentProps.eldData[0]?.perso)
    ) {
      setWplArr(contentProps.eldData[0].perso.slice(11));
    }
  }, [contentProps.eldData]);

  const sortData = (data) => {
    return [...data].sort((a, b) => a.name.localeCompare(b.name));
  };

  const onLogSave = () => {
    setLoading(true);
    const fixedDate = fixDateLog(dateLog);
    const fixedWpl = sameDayWplFixWhileAddingPost(contentProps.userPosts, fixedDate).trim();
    const fixedWorkingH = sameDayWorkingHFixWhileAddingPost(contentProps.userPosts, fixedDate).trim();

    const log = {
      id: ObjectID().toHexString(),
      user: contentProps.loggedUser,
      client: clientLog.toUpperCase(),
      esp: espLog === null ? '' : espLog,
      country: ctyLog === null ? '' : ctyLog,
      lang: langLog === null ? '' : langLog,
      module_type: modTypeLog === null ? '' : modTypeLog,
      module: moduleLog,
      stage: stageLog === null ? '' : stageLog,
      task: taskLog === null ? '' : taskLog,
      hours: hourLog,
      wpl: wplLog === null ? fixedWpl : wplLog,
      workingh: whLog === null ? fixedWorkingH : whLog,
      comment: commentLog === null ? '' : commentLog,
      date: fixedDate,
      cw: contentProps.getCw(fixDateLog(dateLog)),
      ...(clientLog.toUpperCase() === 'ESP' && { version: versionLog ?? '1.0' }),
    };
    fetch(`${API_URL}posts`, {
      method: 'POST',
      mode: 'cors',
      credentials: 'include',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(log),
    })
      .then((response) => {
        if (response.ok) {
          return response.json();
        }
        throw new Error('Network response was not ok.');
      })
      .then((data) => {
        dispatch(fetchInitialPosts(contentProps.loggedUser));
      })
      .catch((error) => {
        console.error('There was a problem with the fetch operation:', error);
      })
      .finally(() => {
        setLoading(false);
        contentProps.setValuesOnInitialState();
      });
  };

  const dialogProps = {
    isDialogOpen: isDialogOpen,
    eldData: contentProps.eldData,
    loggedUser: contentProps.loggedUser,
    onDialogHide: contentProps.onDialogHide,
    setValuesOnInitialState: contentProps.setValuesOnInitialState,
    disabledDays: disabledDays,
    postEditing: contentProps.postEditing,
    onRowEditComplete: contentProps.onRowEditComplete,
    formattedDate: formattedDate,
    formSubmitted: contentProps.formSubmitted,
    setFormSubbmited: contentProps.setFormSubbmited,
    wplArr: wplArr,
    onLogSave: onLogSave,
    sortData: (data) => sortData(data),
    checkIfDayIsPlanned: contentProps.checkIfDayIsPlanned,
    showOverlay: showOverlay,
    setShowOverlay: setShowOverlay,
  };

  return (
    <div className="create-log-wrapper">
      <h2>{dictionary.create_log_hour_report}</h2>
      <Button
        label={dictionary.eld_btn_label}
        icon="pi pi-graduation-cap"
        onClick={() => {
          if (contentProps.checkIfDayIsPlanned(new Date())) {
            dispatch(setClient('eld'));
            dispatch(showEldDialog());
          } else {
            contentProps.showMsg();
          }
        }}
      />
      <Button
        label={dictionary.int_btn_label}
        icon="pi pi-building"
        onClick={() => {
          if (contentProps.checkIfDayIsPlanned(new Date())) {
            dispatch(setClient('int'));
            dispatch(showIntDialog());
          } else {
            contentProps.showMsg();
          }
        }}
      />
      <Button
        label={dictionary.countries_btn_label}
        icon="pi pi-globe"
        onClick={() => {
          if (contentProps.checkIfDayIsPlanned(new Date())) {
            dispatch(setClient('country'));
            dispatch(showCtyDialog());
            dispatch(setModType('FtF'));
          } else {
            contentProps.showMsg();
          }
        }}
      />
      <Button
        label={dictionary.esp_btn_label}
        icon="pi pi-external-link"
        onClick={() => {
          if (contentProps.checkIfDayIsPlanned(new Date())) {
            dispatch(setClient('esp'));
            dispatch(showEspDialog());
            dispatch(setModType('FtF'));
          } else {
            contentProps.showMsg();
          }
        }}
      />
      <Button
        label={dictionary.log_btn_label}
        icon="pi pi-shop"
        onClick={() => {
          if (contentProps.checkIfDayIsPlanned(new Date())) {
            dispatch(setClient('logistics'));
            dispatch(showLogDialog());
          } else {
            contentProps.showMsg();
          }
        }}
      />
      <Button
        label={dictionary.other_btn_label}
        icon="pi pi-plus"
        onClick={() => {
          if (contentProps.checkIfDayIsPlanned(new Date())) {
            dispatch(setClient('other'));
            dispatch(showOthDialog());
          } else {
            contentProps.showMsg();
          }
        }}
      />
      <BlockUI blocked={loading}>
        <div className="dialog-wrapper">{dialogType === 'eld' && <EldComponent dialogProps={dialogProps} />}</div>
        <div className="dialog-wrapper">{dialogType === 'int' && <IntComponent dialogProps={dialogProps} />}</div>
        <div className="dialog-wrapper">
          {dialogType === 'country' && <CountryComponent dialogProps={dialogProps} />}
        </div>
        <div className="dialog-wrapper">
          {dialogType === 'logistic' && <LogisticsComponent dialogProps={dialogProps} />}
        </div>
        <div className="dialog-wrapper">{dialogType === 'other' && <OtherComponent dialogProps={dialogProps} />}</div>
        <div className="dialog-wrapper">
          {dialogType === 'esp' && <EspComponent dialogProps={dialogProps} contentProps={contentProps} />}
        </div>
      </BlockUI>
    </div>
  );
};

export default UserSelection;
